import React from 'react';
import useTabQueryParam from '../../../hooks/useTabQueryParam';
import LeaveSummary from './LeaveSummary';
import LeaveRequest from './LeaveRequest';

const MyData = () => {
  const [activeTab, setActiveTab] = useTabQueryParam('tab', 'summary');

  return (
    <div>
      <div className="flex justify-center gap-4 mb-4">
        <button
          className={`px-4 py-2 rounded-t-md font-medium ${activeTab === 'summary' ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-800 hover:bg-indigo-100'}`}
          onClick={() => setActiveTab('summary')}
        >
          Leave Summary
        </button>
        <button
          className={`px-4 py-2 rounded-t-md font-medium ${activeTab === 'request' ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-800 hover:bg-indigo-100'}`}
          onClick={() => setActiveTab('request')}
        >
          Leave Request
        </button>
      </div>
      <div>
        {activeTab === 'summary' ? <LeaveSummary /> : <LeaveRequest />}
      </div>
    </div>
  );
};

export default MyData;
